import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../../components/states';
// import { useTranslation } from 'react-i18next';
import ResponsibleChildrensForm from '../../../../components/forms/ResponsibleChildrensForm';
import Loader from '../../../../components/Loader';
import { useFetch } from '../../../../hooks/useFetch';

export default function ResponsibleChildrensEditPage() {
  // const { t } = useTranslation();
  const { itemId, parentId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/children/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? (
    <ResponsibleChildrensForm defaultValues={data?.data} parentId={parentId} />
  ) : (
    <Loader />
  );
}
